import { render, staticRenderFns } from "./databoard1.vue?vue&type=template&id=185b455e&"
import script from "./databoard1.vue?vue&type=script&lang=js&"
export * from "./databoard1.vue?vue&type=script&lang=js&"
import style0 from "./databoard1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports